export const NoneIcon = (): JSX.Element => {
    return <></>;
};
